<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Reward Split Policy</strong>
      </div>
    </template>


    <div class="d-flex justify-center mt-n6 ml-6">
      <div class="d-flex flex-column align-center">
        <div style="font-weight: bold; font-size: 32px;">{{ account.settings.user_split_pct }}%</div>
        <div class="mt-n2"  style="font-size: 10px;">Team Member</div>
      </div>
      <div v-if="account.settings.user_split_pct != 100" class="d-flex flex-column align-center ml-6">
        <div style="font-weight: bold; font-size: 32px;">{{ 100 - account.settings.user_split_pct }}%</div>
        <div class="mt-n2" style="font-size: 10px;">Location</div>
      </div>
    </div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'

export default {
  name: 'AccountRewardsSection',

  components: { Section },

  props: ['account'],
}
</script>